// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3ZqMP","signatureButtonsRight":"ModalSign_signatureButtonsRight__71lZr"};